export default __webpack_public_path__ + "static/media/ponentes__ashley albarran.ac2ef8b2.jpg";